import script from "./VerContrato.vue?vue&type=script&lang=ts&setup=true"
export * from "./VerContrato.vue?vue&type=script&lang=ts&setup=true"

import "./VerContrato.vue?vue&type=style&index=0&id=0d163a01&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d163a01"]])

export default __exports__